module.exports = __webpack_public_path__ + "static/sample_Chapter_1-d4635d420b248f565e82e78dd579b279.png";